import { notice } from "@/utils";

const getSuffixName = (str) => {
    const lastSlash = str.split("").findLastIndex((item) => item === "/");
    if (lastSlash !== -1) {
        return str.slice(lastSlash + 1);
    }
    return "";
};
// 下载
export const download = (url, title) => {
    fetch(url)
        .then((res) => {
            res
                .blob()
                .then((blob) => {
                    const blobUrl = window.URL.createObjectURL(blob);
                    const a = document.createElement("a");
                    a.href = blobUrl;
                    a.download = getSuffixName(url);
                    a.click();
                    window.URL.revokeObjectURL(blobUrl);
                })
                .catch((err) => {
                    notice("error", "提示", `${title}下载失败`, 3);
                });
        })
        .catch((err) => {
            notice("error", "提示", `${title}下载失败`, 3);
        });
};
